import type { ProLayoutProps } from "@ant-design/pro-components";
import { PRIMARY_COLOR, WATER_THEME } from "../src/shared/constants/theme";

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  colorPrimary: PRIMARY_COLOR,
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: "泳池数智化运营管理系统",
  pwa: true,
  logo: "/logo.png",
  iconfontUrl: "",
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    sider: {
      colorMenuBackground: WATER_THEME.menuMiddle,
      colorTextMenu: "rgba(255, 255, 255, 0.9)",
      colorTextMenuSelected: "#ffffff",
      colorTextMenuActive: "#ffffff",
      colorTextMenuItemHover: "#ffffff",
      colorBgMenuItemSelected: "rgba(15, 23, 42, 0.2)",
      colorBgMenuItemHover: "rgba(255, 255, 255, 0.12)",
    },
    header: {
      colorBgHeader: "#ffffff",
      colorHeaderTitle: WATER_THEME.text,
      colorTextMenu: WATER_THEME.text,
      colorTextMenuSelected: WATER_THEME.primary,
      colorBgMenuItemSelected: WATER_THEME.primaryLight,
    },
  },
};

export default Settings;
